<template>
  <div>
    <menu-pae :inFocus="false" :isVisible="false">
      <template>
        <div id="menuMesagem">
          <div class="acoes">
            <button class="btn btn-danger" @click.prevent="voltar"> Voltar </button>
            <button class="btn btn-primary" @click.prevent="() => $router.push({ name: 'Inativar Estrutura' })"> Inativar Estruturas </button>
          </div>
        </div>
      </template>
    </menu-pae>

    <alert-comp :msg="alert" :key="alert.key"/>

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/workArea/admin">Admin</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">Estruturas Inativas</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <div class="container mt-2">
      <data-table-consulta-comp class="p-2"
        :colNames="table.columns.names"
        :eventBusDataName="table.event.data"
        :eventBusDataPaginationName="table.event.pagination"
        :renderizarCheckBox="table.checkBox"
        :dataTableColumn="table.columns.attributes">
        <template v-slot="slotProps">
          <td style="text-align: center; width: 100px !important;">
            <i class="fa fa-times text-danger fa-1-5x link" aria-hidden="true"
              v-on:click="remover(slotProps.itemData)"></i>
          </td>
        </template>
      </data-table-consulta-comp>
    </div>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import alertComp from '@/components/alert/AlertComp'
import { localDateParse } from '@/uteis/converters/LocalDateConverter'
import eventBus from '@/uteis/eventBus'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsulta'

import EstruturaService from '@/services/EstruturaService'

export default {
  name: 'estruturas-inativas',
  components: {
    menuPae,
    dataTableConsultaComp,
    alertComp
  },

  created () {
    this.service = new EstruturaService()
    this.pesquisar()
    eventBus.$on(this.table.event.pagination, (page) => {
      this.pesquisar(page)
    })
  },

  data () {
    return {
      alert: {
        texto: '',
        type: '',
        key: true
      },
      filtro: {
        offset: 1,
        range: 10
      },
      table: {
        checkBox: false,
        event: {
          data: 'dataEstruturaInativa',
          pagination: 'paginationEstruturaInativa'
        },
        columns: {
          names: ['Sigla Departamento', 'Sigla Orgão', 'Nome Gestor', 'Data Inativação', 'Ações'],
          attributes: [
            'participante.titulo',
            'participante.participantePai.titulo',
            'atributos.nomeGestor',
            {
              column: 'atributos.dataExclusao',
              converter: 'localDate'
            }
          ]
        }
      }
    }
  },

  methods: {
    voltar () {
      this.$router.back()
    },

    pesquisar (page = 1) {
      this.filtro = {
        ...this.filtro,
        offset: page
      }

      this.service.getEstruturasInativas(this.filtro).then(res => {
        eventBus.$emit(this.table.event.data, {
          data: res.data.data,
          pagination: res.data.pagination
        })
      }).catch(err => {
        console.log(err)
      })
    },

    openText (index) {
      this.choosen = index
    },

    formatData (date) {
      return localDateParse(date).value
    },

    remover (data) {
      const identificador = data.participante.identificador
      this.service.excluirEstruturaInativa(identificador).then(() => {
        this.alert.texto = 'Exclusão realizada com sucesso'
        this.alert.type = 'success'
        this.alert.key = !this.alert.key
        this.pesquisar()
      }).catch(() => {
        this.alert.texto = 'Aconteceu algum erro ao excluir o registro'
        this.alert.type = 'warning'
        this.alert.key = !this.alert.key
      })
    }
  }
}
</script>

<style scoped lang="scss">
.acoes {
  display: flex;
  padding: 15px;
  position: absolute;

  .btn {
    margin-right: 10px;
    width: 150px;
    height: 28px;
  }
}

#dadosElaboracaoProcesso div{
  padding-bottom: 2px;
  padding-top: 2px;

  .btnInteressados {
    padding: 3px 18px;
    border-radius: 4px;
  }
}

.btn {
  //padding: 8px 16px;
  border-radius: 5px;
  &--primary {
    background-color: green;
    color: #fff;
  }
  &--secondary {
    background-color: #dddd;
    color: #000;
  }
}

.interesadoResumidos {
  background-color: white;
}

.interessadosHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: .75rem;
  background-color: rgba(213, 228, 251, 1);

  .titulo {
    color: #0962BD;
    margin: 10px;
  }

  i {
    color: red;
  }
}

.interessadosFooter {
  display: flex;
  justify-content: flex-end;

  .btn {
    margin-left: 5px;
    margin-right: 10px;
  }
}

.overflow-hidden {
  overflow: hidden;
}

.erro {
  color: orange;
}
</style>
